class CollectionVesaFilter extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    this.grid = document.getElementById(this.getAttribute('data-grid-id'));
    this.summary = this.querySelector('[data-vesa-filter-summary]');
    if (!this.select || !this.grid) return;

    this.select.addEventListener('change', () => this.applyFilter());
  }

  applyFilter() {
    const value = this.select.value;
    const items = this.grid.querySelectorAll('.grid__item');
    let visibleCount = 0;

    if (!value) {
      items.forEach((item) => {
        item.hidden = false;
      });
      if (this.summary) this.summary.textContent = '';
      return;
    }

    const [selW, selH] = value.split('x').map((n) => parseInt(n, 10));

    items.forEach((item) => {
      const minW = parseFloat(item.getAttribute('data-vesa-min-w'));
      const minH = parseFloat(item.getAttribute('data-vesa-min-h'));
      const maxW = parseFloat(item.getAttribute('data-vesa-max-w'));
      const maxH = parseFloat(item.getAttribute('data-vesa-max-h'));

      if (isNaN(minW) || isNaN(minH) || isNaN(maxW) || isNaN(maxH)) {
        item.hidden = true;
        return;
      }

      const directFit = selW >= minW && selW <= maxW && selH >= minH && selH <= maxH;
      const rotatedFit = selH >= minW && selH <= maxW && selW >= minH && selW <= maxH;
      const fits = directFit || rotatedFit;

      item.hidden = !fits;
      if (fits) visibleCount += 1;
    });

    if (this.summary) {
      this.summary.textContent = this.getAttribute('data-summary-template').replace('{count}', visibleCount);
    }
  }
}

customElements.define('collection-vesa-filter', CollectionVesaFilter);
